export default __webpack_public_path__ + "static/media/arrow-white.56ace82a.svg";